import React, { Component } from "react";
import { Form, Button, Col, Row, Icon, Tooltip, Drawer, Modal, message, Divider, TimePicker } from "antd";
import axios from "axios";
import Colors from '../utils/Colors';
import InputForm from "./InputForm";
import { getUsuario, saveToken, savePermissoes } from "../utils/LoginManager";
import moment from "moment-timezone";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import CtaCorrenteFrame from './CtaCorrenteFrame';
import PlanoCtaFrame from './PlanoCtaFrame';

const { Item: ItemForm } = Form;

export const COMBO_IMPR_VENDA_BALCAO = [
    {
        key: 'NAO',
        label: 'Não Imprimir'
    },
    {
        key: 'COM',
        label: 'Impressão Completa'
    },
    {
        key: 'CUP',
        label: 'Impressão Cupom'
    },
]

export const COMBO_IMPR_GERENCIAR_VENDAS = [
    {
        key: 'NAO',
        label: 'Não Imprimir'
    },
    {
        key: 'COM',
        label: 'Impressão Completa'
    },
    {
        key: 'CUP',
        label: 'Impressão Cupom'
    },
]

export const COMBO_IMPR_OS = [
    {
        key: 'NAO',
        label: 'Não Imprimir'
    },
    {
        key: 'COM',
        label: 'Impressão Completa'
    },
    {
        key: 'CUP',
        label: 'Impressão Cupom'
    },
    {
        key: 'RED',
        label: 'Impressão Reduzida 2 Vias'
    },
]


class ParametrosForm extends Component {
    state = {
        salvando: false,

        registro: {
            par_cliente: { key: '0' },
            par_fornecedor: { key: '0' },
            par_vendedor: { key: '0' },
            par_cta_corrente_padrao: { key: '0' },
            par_doc_padrao: { key: '0' },
            par_doc_cartao: { key: '0' },
            par_cond_pagto_padrao: { key: '0' },
            par_cond_pagto_informada: { key: '0' },
            par_pc_transf_orig: { key: '0' },
            par_pc_transf_dest: { key: '0' },
            par_pc_venda: { key: '0' },
            par_pc_compra: { key: '0' },
            par_pc_estorno: { key: '0' },
            par_pc_contrato: { key: '0' },
            par_pc_os: { key: '0' },
            par_impr_venda_balcao: { key: 'NAO' },
            par_impr_venda_ger: { key: 'NAO' },
            par_impr_os: { key: 'NAO' },
            par_veiculos_clientes: false,
            par_checklist_completo: false,
            par_baixar_parc_cartao_aut: false,
        },
    }


    componentDidMount() {
        const usuario = getUsuario();
        this.setState({
            usuario,
        }, this.onBuscaParametros());
    }



    onSalvarClick = () => {
        this.setState({ salvando: true })

        const registro = {
            par_cliente: this.state.registro.par_cliente.key ? String(this.state.registro.par_cliente.key) : '',
            par_fornecedor: this.state.registro.par_fornecedor.key ? String(this.state.registro.par_fornecedor.key) : '',
            par_vendedor: this.state.registro.par_vendedor.key ? String(this.state.registro.par_vendedor.key) : '',
            par_cta_corrente_padrao: this.state.registro.par_cta_corrente_padrao.key ? String(this.state.registro.par_cta_corrente_padrao.key) : '',
            par_doc_padrao: this.state.registro.par_doc_padrao.key ? String(this.state.registro.par_doc_padrao.key) : '',
            par_doc_cartao: this.state.registro.par_doc_cartao.key ? String(this.state.registro.par_doc_cartao.key) : '',
            par_cond_pagto_padrao: this.state.registro.par_cond_pagto_padrao.key ? String(this.state.registro.par_cond_pagto_padrao.key) : '',
            par_cond_pagto_informada: this.state.registro.par_cond_pagto_informada.key ? String(this.state.registro.par_cond_pagto_informada.key) : '',
            par_pc_transf_orig: this.state.registro.par_pc_transf_orig.key ? String(this.state.registro.par_pc_transf_orig.key) : '',
            par_pc_transf_dest: this.state.registro.par_pc_transf_dest.key ? String(this.state.registro.par_pc_transf_dest.key) : '',
            par_pc_venda: this.state.registro.par_pc_venda.key ? String(this.state.registro.par_pc_venda.key) : '',
            par_pc_compra: this.state.registro.par_pc_compra.key ? String(this.state.registro.par_pc_compra.key) : '',
            par_pc_estorno: this.state.registro.par_pc_estorno.key ? String(this.state.registro.par_pc_estorno.key) : '',
            par_pc_contrato: this.state.registro.par_pc_contrato.key ? String(this.state.registro.par_pc_contrato.key) : '',
            par_pc_os: this.state.registro.par_pc_os.key ? String(this.state.registro.par_pc_os.key) : '',
            par_impr_venda_balcao: this.state.registro.par_impr_venda_balcao.key ? String(this.state.registro.par_impr_venda_balcao.key) : '',
            par_impr_venda_ger: this.state.registro.par_impr_venda_ger.key ? String(this.state.registro.par_impr_venda_ger.key) : '',
            par_impr_os: this.state.registro.par_impr_os.key ? String(this.state.registro.par_impr_os.key) : '',
            par_termos_os: this.state.registro.par_termos_os ? String(this.state.registro.par_termos_os) : '',
            par_termos_orcamento: this.state.registro.par_termos_orcamento ? String(this.state.registro.par_termos_orcamento) : '',
            par_veiculos_clientes: this.state.registro.par_veiculos_clientes ? 1 : 0,
            par_checklist_completo: this.state.registro.par_checklist_completo ? 1 : 0,
            par_baixar_parc_cartao_aut: this.state.registro.par_baixar_parc_cartao_aut ? 1 : 0,
        };



        const usuario = getUsuario();
        const body = {
            usuario: usuario.usu_email,
            senha: 'e807f1fcf8',
            empresa: usuario.emp_codigo,
        };

        axios.put('/parametros/update', registro)
            .then(response => {

                axios.post("/usuarios/login", body)
                    .then(response => {
                        saveToken(response.data.token);
                        savePermissoes(response.data.grupo);
                        this.setState({ salvando: false })
                        message.success('Configurações gravada com sucesso.');
                    })
                    .catch(error => {
                        console.error(error.response);
                        this.setState({ salvando: false })
                        Modal.error({ title: 'Falha - Atenção!', content: 'Configurações salvas, faço login novemante. ' + error.response.data, okText: 'OK', })
                    });
            })
            .catch(error => {
                console.error(error.response);
                this.setState({ salvando: false })
                Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            })

    }


    onBuscaParametros = registro => {
        this.setState({ carregando: true });
        axios.get(`/parametros/getPararametros`)
            .then(response => {
                const { data } = response;

                // console.log('onBuscaParametros: ', data);

                data.par_cliente = {
                    key: data.par_cliente ? String(data.par_cliente) : "0",
                    label: data.par_cliente ? data.nomeCliente : "",
                }
                data.par_fornecedor = {
                    key: data.par_fornecedor ? String(data.par_fornecedor) : "0",
                    label: data.par_fornecedor ? data.nomeFornec : '',
                }
                data.par_vendedor = {
                    key: data.par_vendedor ? String(data.par_vendedor) : "0",
                    label: data.par_vendedor ? data.usu_nome : '',
                }
                data.par_cta_corrente_padrao = {
                    key: data.par_cta_corrente_padrao ? String(data.par_cta_corrente_padrao) : "0",
                    label: data.par_cta_corrente_padrao ? data.cc_descricao : "",
                }
                data.par_doc_padrao = {
                    key: data.par_doc_padrao ? String(data.par_doc_padrao) : "0",
                    label: data.par_doc_padrao ? data.td_descricao : "",
                }
                data.par_doc_cartao = {
                    key: data.par_doc_cartao ? String(data.par_doc_cartao) : "0",
                    label: "",
                }
                data.par_cond_pagto_padrao = {
                    key: data.par_cond_pagto_padrao ? String(data.par_cond_pagto_padrao) : "0",
                    label: data.par_cond_pagto_padrao ? data.cp_descricaoPadrao : "",
                }
                data.par_cond_pagto_informada = {
                    key: data.par_cond_pagto_informada ? String(data.par_cond_pagto_informada) : "0",
                    label: data.par_cond_pagto_informada ? data.cp_descricaoInfor : "",
                }

                data.par_pc_transf_orig = {
                    key: data.par_pc_transf_orig ? String(data.par_pc_transf_orig) : "0",
                    label: data.par_pc_transf_orig ? data.pc_descricaoOrig : "",
                }
                data.par_pc_transf_dest = {
                    key: data.par_pc_transf_dest ? String(data.par_pc_transf_dest) : "0",
                    label: data.par_pc_transf_dest ? data.pc_descricaoDest : "",
                }
                data.par_pc_venda = {
                    key: data.par_pc_venda ? String(data.par_pc_venda) : "0",
                    label: data.par_pc_venda ? data.pc_descricaoVenda : "",
                }
                data.par_pc_compra = {
                    key: data.par_pc_compra ? String(data.par_pc_compra) : "0",
                    label: data.par_pc_compra ? data.pc_descricaoCompra : "",
                }
                data.par_pc_estorno = {
                    key: data.par_pc_estorno ? String(data.par_pc_estorno) : "0",
                    label: data.par_pc_estorno ? data.pc_descricaoEstorno : "",
                }
                data.par_pc_contrato = {
                    key: data.par_pc_contrato ? String(data.par_pc_contrato) : "0",
                    label: data.par_pc_contrato ? data.pc_descricaoEstorno : "",
                }
                data.par_pc_os = {
                    key: data.par_pc_os ? String(data.par_pc_os) : "0",
                    label: data.par_pc_os ? data.pc_descricaoOS : "",
                }
                data.par_impr_venda_balcao = {
                    key: data.par_impr_venda_balcao ? String(data.par_impr_venda_balcao) : "NAO",
                    label: "",
                }
                data.par_impr_venda_ger = {
                    key: data.par_impr_venda_ger ? String(data.par_impr_venda_ger) : "NAO",
                    label: "",
                }
                data.par_impr_os = {
                    key: data.par_impr_os ? String(data.par_impr_os) : "NAO",
                    label: "",
                }

                this.setState({
                    registro: data,
                    carregando: false,
                })
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                })
            })
    };



    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        const { registro } = this.state;
        registro[id] = value;
        this.setState({ [id]: value });
    };

    onChangePessoaCliente = event => {
        const { registro } = this.state;
        registro['par_cliente'] = event.par_cliente;
        this.setState(event);
    }

    onChangePessoaFornec = event => {
        const { registro } = this.state;
        registro['par_fornecedor'] = event.par_fornecedor;
        this.setState(event);
    }

    onChangeVendedor = event => {
        const { registro } = this.state;
        registro['par_vendedor'] = event.par_vendedor;
        this.setState(event);
    }

    onChangeCtaCorrente = event => {
        const { registro } = this.state;
        registro['par_cta_corrente_padrao'] = event.par_cta_corrente_padrao;
        this.setState(event);
    }

    onChangeTipoDoc = event => {
        const { registro } = this.state;
        registro['par_doc_padrao'] = event.par_doc_padrao;
        this.setState(event);
    }

    onChangeTipoDocCartao = event => {
        const { registro } = this.state;
        registro['par_doc_cartao'] = event.par_doc_cartao;
        this.setState(event);
    }

    onChangeCondPagtoPadrao = event => {
        const { registro } = this.state;
        registro['par_cond_pagto_padrao'] = event.par_cond_pagto_padrao;
        this.setState(event);
    }

    onChangeCondPagtoInfor = event => {
        const { registro } = this.state;
        registro['par_cond_pagto_informada'] = event.par_cond_pagto_informada;
        this.setState(event);
    }

    onChangePlanoCtaVenda = event => {
        const { registro } = this.state;
        registro['par_pc_venda'] = event.par_pc_venda;
        this.setState(event);
    }

    onChangePlanoCtaOS = event => {
        const { registro } = this.state;
        registro['par_pc_os'] = event.par_pc_os;
        this.setState(event);
    }

    onChangePlanoCtaCompra = event => {
        const { registro } = this.state;
        registro['par_pc_compra'] = event.par_pc_compra;
        this.setState(event);
    }

    onChangePlanoCtaEstorno = event => {
        const { registro } = this.state;
        registro['par_pc_estorno'] = event.par_pc_estorno;
        this.setState(event);
    }

    onChangePlanoCtaContrato = event => {
        const { registro } = this.state;
        registro['par_pc_contrato'] = event.par_pc_contrato;
        this.setState(event);
    }

    onChangePlanoCtaOrigem = event => {
        const { registro } = this.state;
        registro['par_pc_transf_orig'] = event.par_pc_transf_orig;
        this.setState(event);
    }

    onChangePlanoCtaDestino = event => {
        const { registro } = this.state;
        registro['par_pc_transf_dest'] = event.par_pc_transf_dest;
        this.setState(event);
    }

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;

        const { registro } = this.state;
        registro[id] = value;

        this.setState({
            [id]: value
        });
    };



    render() {
        const { salvando, carregando, OPCOES_COMBO_PAGTO } = this.state;
        const { par_cliente, par_fornecedor, par_cta_corrente_padrao, par_doc_padrao, par_doc_cartao,
            par_cond_pagto_padrao, par_cond_pagto_informada, par_pc_transf_orig, par_pc_transf_dest,
            par_pc_venda, par_pc_compra, par_pc_estorno, par_pc_contrato, par_pc_os, par_vendedor,
            par_impr_venda_balcao, par_impr_venda_ger, par_impr_os, par_termos_os, par_termos_orcamento,
            par_veiculos_clientes, par_checklist_completo, par_baixar_parc_cartao_aut
        } = this.state.registro;

        // console.log('ParametrosForm.state: ', this.state);

        return (
            <div>
                <span className="tituloPage">Configurações Gerais do Sistema</span>
                <div className="divider-page1" />

                <div style={{ marginTop: 30 }}>
                    <Row>
                        <Col xs={24} md={8} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PessoaFrame
                                label="Cliente Padrão"
                                id="par_cliente"
                                value={par_cliente}
                                tipo="C"
                                width={"100%"}
                                onChange={this.onChangePessoaCliente}
                                descricaoPrimeiroItem="Informe o Cliente"
                            />
                        </Col>
                        <Col xs={24} md={8} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PessoaFrame
                                label="Fornecedor Padrão"
                                id="par_fornecedor"
                                value={par_fornecedor}
                                tipo="F"
                                width={"100%"}
                                onChange={this.onChangePessoaFornec}
                                descricaoPrimeiroItem="Informe o Fornecedor"
                            />
                        </Col>
                        <Col xs={24} md={8} style={{ marginTop: -15 }}>
                            <UsuarioFrame
                                label="Vendedor Padrão"
                                id="par_vendedor"
                                value={par_vendedor}
                                width={"100%"}
                                vendedor={1}
                                onChange={this.onChangeVendedor}
                                descricaoPrimeiroItem="Selecione o Vendedor"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <CtaCorrenteFrame
                                label="Conta Corrente Padrão"
                                id="par_cta_corrente_padrao"
                                value={par_cta_corrente_padrao}
                                width={"100%"}
                                onChange={this.onChangeCtaCorrente}
                                descricaoPrimeiroItem="Informe a Conta Corrente"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <TipoDocFrame
                                label="Tipo Documento Padrão"
                                id="par_doc_padrao"
                                value={par_doc_padrao}
                                width={"100%"}
                                onChange={this.onChangeTipoDoc}
                                descricaoPrimeiroItem="Informe o Tipo de Documento"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <TipoDocFrame
                                label="Tipo Documento Cartão"
                                id="par_doc_cartao"
                                value={par_doc_cartao}
                                width={"100%"}
                                onChange={this.onChangeTipoDocCartao}
                                descricaoPrimeiroItem="Informe o Tipo de Documento"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }}>
                            <CondPagtoFrame
                                label="Cond Pgto Padrão"
                                id="par_cond_pagto_padrao"
                                value={par_cond_pagto_padrao}
                                width={"100%"}
                                onChange={this.onChangeCondPagtoPadrao}
                                descricaoPrimeiroItem="Informe a Condição de Pagamento"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <CondPagtoFrame
                                label="Cond Pgto Informada"
                                id="par_cond_pagto_informada"
                                value={par_cond_pagto_informada}
                                width={"100%"}
                                onChange={this.onChangeCondPagtoInfor}
                                descricaoPrimeiroItem="Informe a Condição de Pagamento"
                            />
                        </Col>


                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PlanoCtaFrame
                                label="Conta Financeira Venda"
                                id="par_pc_venda"
                                value={par_pc_venda}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaVenda}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PlanoCtaFrame
                                label="Conta Financeira O.S"
                                id="par_pc_os"
                                value={par_pc_os}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaOS}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }}>
                            <PlanoCtaFrame
                                label="Conta Financeira Compra"
                                id="par_pc_compra"
                                value={par_pc_compra}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaCompra}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PlanoCtaFrame
                                label="Conta Financeira Estorno/Cancelar Venda"
                                id="par_pc_estorno"
                                value={par_pc_estorno}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaEstorno}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PlanoCtaFrame
                                label="Conta Financeira para Contratos"
                                id="par_pc_contrato"
                                value={par_pc_contrato}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaContrato}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <PlanoCtaFrame
                                label="Conta Financeira Transf. Origem"
                                id="par_pc_transf_orig"
                                value={par_pc_transf_orig}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaOrigem}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>
                        <Col xs={24} md={6} style={{ marginTop: -15 }}>
                            <PlanoCtaFrame
                                label="Conta Financeira Trtansf. Destino"
                                id="par_pc_transf_dest"
                                value={par_pc_transf_dest}
                                width={"100%"}
                                onChange={this.onChangePlanoCtaDestino}
                                descricaoPrimeiroItem="Informe a Conta Financeira"
                            />
                        </Col>

                        <Col xs={24} md={8} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <span>Impressão na Tela Venda Balcão</span>
                            <InputForm
                                type="select"
                                id="par_impr_venda_balcao"
                                ref="par_impr_venda_balcao"
                                value={par_impr_venda_balcao}
                                placeholder="Selecione o Tipo"
                                onChange={this.onChange}
                                data={COMBO_IMPR_VENDA_BALCAO}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>

                        <Col xs={24} md={8} style={{ marginTop: -15 }} className="camposEspacoDireita">
                            <span>Impressão na Tela Gerenciar Vendas</span>
                            <InputForm
                                type="select"
                                id="par_impr_venda_ger"
                                ref="par_impr_venda_ger"
                                value={par_impr_venda_ger}
                                placeholder="Selecione o Tipo"
                                onChange={this.onChange}
                                data={COMBO_IMPR_GERENCIAR_VENDAS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>

                        <Col xs={24} md={8} style={{ marginTop: -15 }}>
                            <span>Impressão na Tela O.S</span>
                            <InputForm
                                type="select"
                                id="par_impr_os"
                                ref="par_impr_os"
                                value={par_impr_os}
                                placeholder="Selecione o Tipo"
                                onChange={this.onChange}
                                data={COMBO_IMPR_OS}
                                validator={value => Boolean(value)}
                                style={{ width: "100%" }}
                            />
                        </Col>

                        <Col xs={24} sm={8} style={{ marginTop: -30, marginBottom: 10 }} className="campoCheckBox">
                            <InputForm
                                type="checkbox"
                                id="par_veiculos_clientes"
                                ref="par_veiculos_clientes"
                                onChange={this.onChange}
                                value={par_veiculos_clientes ? true : false}
                            >
                                Controle de Veículos dos Clientes
                            </InputForm>
                        </Col>

                        <Col xs={24} sm={8} style={{ marginTop: -30, marginBottom: 10 }} className="campoCheckBox">
                            <InputForm
                                type="checkbox"
                                id="par_checklist_completo"
                                ref="par_checklist_completo"
                                onChange={this.onChange}
                                value={par_checklist_completo ? true : false}
                            >
                                Check-List Completa para Ordem de Serviço
                            </InputForm>
                        </Col>

                        <Col xs={24} sm={8} style={{ marginTop: -30, marginBottom: 10 }} className="campoCheckBox">
                            <InputForm
                                type="checkbox"
                                id="par_baixar_parc_cartao_aut"
                                ref="par_baixar_parc_cartao_aut"
                                onChange={this.onChange}
                                value={par_baixar_parc_cartao_aut ? true : false}
                            >
                                Baixar parcelas do cartão automaticamente no dia do vencimento
                            </InputForm>
                        </Col>

                        <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                            <span>Texto Termos Orçamento</span>
                            <InputForm
                                id="par_termos_orcamento"
                                ref="par_termos_orcamento"
                                value={par_termos_orcamento}
                                type="textarea"
                                rows={5}
                                maxLength={9500}
                                onChange={this.onChange}
                                validator={value => Boolean(value)}
                            />
                        </Col>

                        <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                            <span>Texto Termos O.S</span>
                            <InputForm
                                id="par_termos_os"
                                ref="par_termos_os"
                                value={par_termos_os}
                                type="textarea"
                                rows={5}
                                maxLength={9500}
                                onChange={this.onChange}
                                validator={value => Boolean(value)}
                            />
                        </Col>

                        <Divider />

                    </Row>
                </div>


                <div style={{ marginBottom: 50 }}>
                    <div className="divider-form" />
                    <ItemForm>
                        <Row>
                            <Col xs={24}>
                                <Button
                                    type="primary"
                                    htmlType="button"
                                    loading={salvando}
                                    onClick={this.onSalvarClick}
                                    className="btn-salvar"
                                >
                                    Salvar
                                </Button>
                            </Col>
                        </Row>
                    </ItemForm>
                </div>


            </div >
        );
    }
}

export default ParametrosForm;



// WEBPACK FOOTER //
// ./src/components/ParametrosForm.js